import React from 'react';
import { Card, CardGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './SingleService.css'

const SingleService = ({ service }) => {
    const { img, name, price, description } = service
    return (
        <div className='col-md-4'>
            <CardGroup>
                <Card>
                    <Card.Img variant="top" src={img} />
                    <Card.Body>
                        <Card.Title>{name}</Card.Title>
                        <h3>{price}</h3>
                        <Card.Text title={description}>
                            {description.slice(0, 180)}...
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer className='bg-success'>
                        <button className='btn btn-success w-100'><Link to='/checkout' className='text-white'>Book Now</Link></button>
                    </Card.Footer>
                </Card>
            </CardGroup>
        </div>
    );
};

export default SingleService;